import { create } from 'zustand';

import { type CanvasImageEditAction, type SmartResizeFormat } from '@air/feature-edit-canvas';

export type PendingCanvasEditAction = CanvasImageEditAction | 'open' | 'videoConvert' | 'videoExtend';

/** A saved size set resolved to its image smart-resize formats when the menu item is picked. */
export type EditInCanvasSizeSet = {
  formats: SmartResizeFormat[];
  id: string;
  name: string;
};

export type PendingCanvasEditRequest =
  | { action: PendingCanvasEditAction }
  | { action: 'resizeForSet'; sizeSet: EditInCanvasSizeSet };

export type PendingCanvasEdit = PendingCanvasEditRequest & {
  nodeId: string;
};

type State = {
  clearPending: () => void;
  pending: PendingCanvasEdit | null;
  setPending: (pending: PendingCanvasEdit) => void;
};

/**
 * Carries a gallery "edit in canvas" intent into the editor. The image or video node id is
 * minted client-side before the canvas exists, so it can be handed over up front and consumed by
 * `CanvasPendingEdit` once that node is on a live canvas.
 *
 * Deliberately not persisted: a stale intent would reopen a tool in a later session.
 */
export const usePendingCanvasEditStore = create<State>((set) => ({
  clearPending: () => set({ pending: null }),
  pending: null,
  setPending: (pending) => set({ pending }),
}));
